import { render } from "./PostComponent.vue?vue&type=template&id=05cc0f33&scoped=true"
import script from "./PostComponent.vue?vue&type=script&lang=js"
export * from "./PostComponent.vue?vue&type=script&lang=js"

import "./PostComponent.vue?vue&type=style&index=0&id=05cc0f33&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05cc0f33"

export default script